<template>
<div class="component">
    <div class="settingsmenu" v-if="isOpen" @click="closeMenu()">
        <transition name="topanimation" appear>

            <div class="topContainer " @click="openUserAdministration()" @mouseover="hoveredElement = 'top'" @mouseleave="hoveredElement = ''">
                <div class="settingsMenuItemContainer" :class="{'hovereditem':hoveredElement=='top'}">
                    <div class="settingsMenuInnerItemContainer">
                        <i class="fas fa-user"></i>
                    </div>
                </div>

            </div>

        </transition>
        <transition name="bottomanimation" appear>

            <div class="bottomContainer" @click="logout()" @mouseover="hoveredElement = 'bottom'" @mouseleave="hoveredElement = ''">
                <div class="settingsMenuItemContainer" :class="{'hovereditem':hoveredElement=='bottom'}">
                    <div class="settingsMenuInnerItemContainer">
                        <i class="fas fa-sign-out-alt"></i>
                    </div>
                </div>
            </div>
        </transition>

        <transition name="leftanimation" appear>

            <div class="leftContainer" @mouseover="hoveredElement = 'left'" @mouseleave="hoveredElement = ''">
                <div class="settingsMenuItemContainer" :class="{'hovereditem':hoveredElement=='left'}">
                    <div class="settingsMenuInnerItemContainer">
                        <i class="fas fa-cogs"></i>
                    </div>
                </div>
            </div>
        </transition>
        <transition name="rightanimation" appear>

            <div class="rightContainer" @click="goToProjectPage()" @mouseover="hoveredElement = 'right'" @mouseleave="hoveredElement = ''">
                <div class="settingsMenuItemContainer" :class="{'hovereditem':hoveredElement=='right'}">
                    <div class="settingsMenuInnerItemContainer">
                        <i class="fas fa-project-diagram"></i>
                    </div>
                </div>
            </div>
        </transition>
    </div>

</div>
</template>

<script>
export default {
    name: 'settingsmenu',
    props: ["isOpen"],
    mounted: function () {},
    data() {
        return {
            msg: 'Welcome to Your Vue.js App',
            data: [],
            hoveredElement:""
        }
    },
    methods: {
        logout() {
            this.$store.commit('setUsername', null)
            this.$store.commit('setUserRole', null)
            this.$store.commit('setUser', null)
            localStorage.bearertoken = null;
            this.$router.push({
                name: 'Login'
            })
        },
        openUserAdministration() {
            this.$router.push({
                name: 'UserAdministration'
            })
        },
        closeMenu() {
            this.$emit("close")
        },
            goToProjectPage() {
            this.$router.push({
                name: 'Projects'
            })

        }
    },
    computed: {},
}
</script>

<style scoped>
.settingsmenu {
    position: absolute;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1000;
}

.settingsMenuItemContainer {
    background: white;
    font-size: 8vh;
    width: 10vw;
    height: 10vw;
    transform: rotate(45deg);

}

.settingsMenuInnerItemContainer {
    width: 10vw;
    height: 10vw;
    line-height: 10vw;
    transform: rotate(-45deg);
    cursor:pointer;

}

.topContainer {
    position: absolute;
    left: 50vw;
    top: 32vh;
    transform: translate(-50%, -50%);
}

.bottomContainer {
    position: absolute;
    left: 50vw;
    top: 68vh;
    transform: translate(-50%, -50%)
}

.leftContainer {
    position: absolute;
    left: 40vw;
    top: 50vh;
    transform: translate(-50%, -50%)
}

.rightContainer {
    position: absolute;
    left: 60vw;
    top: 50vh;
    transform: translate(-50%, -50%)
}

.hovereditem{
    background:rgb(200,200,200);
}

.topanimation-enter,
.topanimation-leave-to {
    top: 0
}

.topanimation-leave,
.topanimation-enter-to {
    top: 32vh
}

.topanimation-enter-active,
.topanimation-leave-active {
    transition: 0.5s
}

.bottomanimation-enter,
.bottomanimation-leave-to {
    top: 100vh
}

.bottomanimation-leave,
.bottomanimation-enter-to {
    top: 68vh
}

.bottomanimation-enter-active,
.bottomanimation-leave-active {
    transition: 0.5s
}

.leftanimation-enter,
.leftanimation-leave-to {
    left: 0vw
}

.leftanimation-leave,
.leftanimation-enter-to {
    left:40vw
}

.leftanimation-enter-active,
.leftanimation-leave-active {
    transition: 0.5s
}



.rightanimation-enter,
.rightanimation-leave-to {
    left: 100vw
}

.rightanimation-leave,
.rightanimation-enter-to {
    left:60vw
}

.rightanimation-enter-active,
.rightanimation-leave-active {
    transition: 0.5s
}
</style>
